import type { LocationQueryValue } from 'vue-router'

export const appendToParams = (params: URLSearchParams, key: string) => (value: LocationQueryValue) => {
  if (value) {
    params.append(`${key}[]`, value.toString().trim())
  }
}
